import { HttpErrorResponse } from '@angular/common/http';
import { AfterContentChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import FiltrosHistoriaAdmisionEntity from 'src/app/classes/FiltrosHistoriaAdmisionEntity';
import TratamientoAsistencialEntity from 'src/app/classes/TratamientoAsistencialEntity';
import { LoginEntity } from 'src/app/interfaces/login';
import { EntidadEmpresarialEntity, ServicioEntidadService } from 'src/app/services/servicio-entidad.service';
import { FiltrosFormatoAsistencialEntity, FormatoAsistencialEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { ServicioParametroSimensService } from 'src/app/services/servicio-parametro-simens.service';

@Component({
  selector: 'app-admision',
  templateUrl: './admision.component.html',
  styleUrls: ['./admision.component.css']
})
export class AdmisionComponent implements OnInit, AfterContentChecked {

  canLoad: boolean = false;
  loading: boolean = false;
  errorGeneral: boolean = false;
  loadingUser: boolean = false;
  mensajeError: string;

  entidad: EntidadEmpresarialEntity;
  filtros: FiltrosHistoriaAdmisionEntity;
  filtrosHc: FiltrosFormatoAsistencialEntity;
  datosEncabezado: FormatoAsistencialEntity[] = [];
  parametroSimens: any;
  ttas: TratamientoAsistencialEntity[] = [];

  constructor(private activatedRoute: ActivatedRoute,
              private servicioEntidad: ServicioEntidadService,
              private servicioSimens: ServicioParametroSimensService,
              private servicioFormato: ServicioFormatoAsistencialService,
              private changeDet: ChangeDetectorRef) {
    this.filtros = new FiltrosHistoriaAdmisionEntity();
    this.activatedRoute.params.subscribe(params => {
      this.filtros.codigoBaseDatos = params['codigoBaseDatos'];
      this.filtros.sede = Number(params['uncoSede']);
      this.filtros.uncoLogin = Number(params['uncoLogin']);
    });
    
    this.activatedRoute.queryParams.subscribe(params => {
      this.filtros.uncoAdmision = Number(params['adm']);
      this.filtros.firma = params['frma'] && params['frma'] == 'true' ? true : false;
      this.filtros.diligenciados = params['dlgncds'] && params['dlgncds'] == 'true' ? true : false;
      this.filtros.ordenCronologico = params['ordn'] && params['ordn'] == 'true' ? true : false;
      this.filtros.evoluciones = params['evlcns'] && params['evlcns'] == 'true' ? true : false;
      this.filtros.notas = params['nts'] && params['nts'] == 'true' ? true : false;
      this.filtros.solicitudServicios = params['srvcs'] && params['srvcs'] == 'true' ? true : false;
      this.filtros.triagge = false;
    })
  }

  ngOnInit() {
    this.loadingUser = true;
    this.servicioFormato.clearTemporalWait();
    this.getTratamientosByAdmision();
  }

  ngAfterContentChecked(): void {
    this.changeDet.detectChanges();
  }

  public onFiltrosCompletados(filtros: FiltrosHistoriaAdmisionEntity) {
    this.setFiltros(filtros);
    this.ttas = filtros.ttasSelected;
    this.canLoad = filtros.canLoad;

    if (this.canLoad) {
      if (!filtros.canImpresion) {
        this.onPrepareControlImpresion();
      }
      this.loading = true;
      this.getEntidadEmpresarial();  
    } else {
      this.onPrepareControlImpresion();
    }    
  }

  public onError(error: string) {
    this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> ${error}`;
  }

  async getTratamientosByAdmision() {
    try {
      const request = await this.servicioFormato.getTratamientosByAdmision(this.filtros.codigoBaseDatos, this.filtros.uncoAdmision);
      if (request != null) {
        request.subscribe((data: TratamientoAsistencialEntity[]) => {
          if (data && data.length > 0) {
            this.filtros.ttas = data;
            this.getUsuario();
          } else {
            this.errorGeneral = true;
            this.loadingUser = false;
            this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de las historia, verifique conexión a internet o reporte caso al administrador.`;
          }
        }, (err: HttpErrorResponse) => {
          console.log('Inicia TTa 2');
          this.errorGeneral = true;
          this.loadingUser = false;
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de las historia, verifique conexión a internet o reporte caso al administrador.`;
        });
      }
    } catch (err) {
      console.error('getTratamientosByadmision()', err);
    }
  }

  async getUsuario() {
    try {
      const request = await this.servicioFormato.getInformacionLogin(this.filtros.codigoBaseDatos, this.filtros.uncoLogin);
      if (request != null) {
        request.subscribe((login: LoginEntity) => {
          this.filtros.login = login;
          this.filtros.user = login.usuario;
          setTimeout(() => {
            this.loadingUser = false;  
          }, 0);
          
        }, (err: HttpErrorResponse) => {
          this.loadingUser = false;
          console.error('AdmsionComponent.getUsuario()', err);
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos del usuario, reporte caso al administrador`;
        });
      }
    } catch (e) {
      console.error('Catch AdmsionComponent.getUsuario()', e);
      this.loadingUser = false;
    }
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.filtrosHc.codigoBaseDatos, this.filtrosHc.sede);
      if (response != null) {
        response.subscribe((data: any) => {
          if (data) {
            this.entidad = data[0];
            this.filtrosHc.entidadEmpresarial = this.entidad;
            this.getParametroSimens(this.filtrosHc.sede);
          } else {
            this.loading = false;
            console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Entidades resueltas nulas ');
            this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
          }
        }, (err: HttpErrorResponse) => {
          this.loading = false;
          console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial()', err);
          this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
        });
      }
    } catch (e) {
      this.loading = false;
      console.error('Catch getEntidadEmpresarial()', e);
      this.mensajeError = `<i class='fa fa-exclamation-triangle'></i> Error al intentar obtener datos de la entidad, reporte caso al administrador.`;
    }
  }

  async getParametroSimens(sede: number) {
    try {
      const response = await this.servicioSimens.getParametroSimensBySede(this.filtrosHc.codigoBaseDatos, this.filtrosHc.sede);
      if (response != null) {
        response.subscribe((data: any) => {
          this.parametroSimens = data;
          this.filtrosHc.parametroSimens = data;
          this.getLogo();
        }, (err: HttpErrorResponse) => {
          this.parametroSimens = null;
          console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Parametro Simens Nulo ');
          console.error('Error getParametroSimens()', err);
        });
      }
    } catch (e) {
      this.parametroSimens = null;
      console.error('Catch getParametroSimens()', e);
      console.error('Error Reporte-formato-asistencial.getEntidadEmpresarial(): Parametro Simens Nulo ');
    }
  }

  async getLogo() {
    try {
      const response = await this.servicioFormato.getLogoEntidadEmpresarial(this.filtrosHc.codigoBaseDatos, { idEntidad: this.entidad.unco});
      if (response != null) {
        response.subscribe((data: any) => {
          this.entidad.urlLogo = data.source;
          this.getEncabezados();
        }, (err: HttpErrorResponse) => {
          console.error('Error getLogo()', err);
          this.entidad.urlLogo = '/assets/img/empty.png';
          this.loading = false;
          this.mensajeError = null;
        });
      }
    } catch (e) {
      console.error('Catch getLogo()', e);
      this.entidad.urlLogo = '/assets/img/empty.png';
      this.loading = false;
      this.mensajeError = null;
    }
  }

  async getEncabezados() {
    this.datosEncabezado = [];
    for (let i = 0; i < this.ttas.length; i ++ ) {
      let tta = this.ttas[i];
      const response = await this.servicioFormato.getHeaderFormatoAsistencial(this.filtrosHc.codigoBaseDatos, tta.id);
      if (response != null) {
        response.subscribe((data: FormatoAsistencialEntity) => {
          let filtrosEncabezado = this.getFiltros();
          filtrosEncabezado.tta = tta.id;
          data.filtros = filtrosEncabezado;
          this.datosEncabezado.push(data);

          if (this.datosEncabezado.length === this.ttas.length) {
            if (this.filtros.ordenCronologico) {
              this.datosEncabezado = this.datosEncabezado.sort((a: FormatoAsistencialEntity, b: FormatoAsistencialEntity) => a.fechaAtencion - b.fechaAtencion);
            }
            this.loading = false;
            this.mensajeError = null;
          }
        })
      }
    }
  }

  // Auxiliares

  setFiltros(filtros: FiltrosHistoriaAdmisionEntity) {
    this.filtrosHc = {
      codigoBaseDatos : filtros.codigoBaseDatos,
      diligenciados : filtros.diligenciados,
      evoluciones : filtros.evoluciones,
      firmaProfesional : filtros.firma,
      notas : filtros.notas,
      solicitudServicios : filtros.solicitudServicios,
      marcaAgua : '',
      sede : filtros.sede,
      user : filtros.user,
      uncoLogin : filtros.uncoLogin,
      canLoad : filtros.canLoad,
      canImpresion : filtros.canImpresion
    }
  }

  getFiltros() {
    let filters: FiltrosFormatoAsistencialEntity = {
      codigoBaseDatos : this.filtros.codigoBaseDatos,
      diligenciados : this.filtros.diligenciados,
      evoluciones : this.filtros.evoluciones,
      firmaProfesional : this.filtros.firma,
      notas : this.filtros.notas,
      solicitudServicios : true,
      marcaAgua : '',
      sede : this.filtros.sede,
      user : this.filtros.user,
      uncoLogin : this.filtros.uncoLogin
    };
    return filters;
  }

  onPrepareControlImpresion() {
    window.addEventListener('keydown', (event: any) => {
      if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
        event.preventDefault();
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        } else {
            event.stopPropagation();
        }
        return;
      }
    });

    window.addEventListener('keyup', (event: any) => {
      if (event.keyCode === 44) {
        this.copyToClipboard();
      }
    });

    window.addEventListener('contextmenu', (event: any) => {
      event.preventDefault();
    });

  }

  copyToClipboard() {
    const aux = document.createElement('input');
    aux.setAttribute('value', 'Impresiones de pantalla deshabilitadas !');
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);
    alert('Impresiones de pantalla deshabilitadas !');
  }

  isLoading() {
    return this.loading || this.loadingUser;
  }

}
